export default __webpack_public_path__ + "static/media/next.6b903434.svg";